<template>
	<main class="audio-player-cont">
		<div class="audio-player-gradient"></div>
		<div class="audio-player-elements stack-vertical">
			<div class="audio-player-top">
				<div class="audio-player-spacer"></div>
				<p class="font-caption-maiusc">{{$t('scrolly_tipologia_contenuto_player_percorso')}}</p>
				<base-button-rounded icon="e-remove-2" color="var(--color-gold)" icon-color="var(--color-black)" class="audio-player-exit" @click="exitPlayer"/>
			</div>
			<div class="audio-player-contents stack-vertical">
				<div class="audio-player-texts stack-vertical">
					<div class="audio-player-title stack-vertical">
						<h2 class="capitalize-first">{{title}}</h2>
					</div>
					<div class="audio-player-audio-data">
						<p class="font-medium capitalize-first">{{currentStageString}}</p>
						<p>{{timeProgress}}</p>
					</div>
				</div>
				<div class="audio-player-progress relative">
					<div class="audio-player-progress-bar relative">
						<div class="audio-player-progress-amount" :style="progressStyle"></div>
						<div class="audio-player-progress-index" :style="`left: ${this.progressAmount}px;`"></div>
					</div>
				</div>
			</div>
			<div class="audio-player-controls stack-horizontal">
				<base-icon :class="`${stages.length <= 3 ? 'deactivated' : 'pointer'}`" name="button-previous-2" @click="playerAction('go-prev-stage')" />
				<base-icon class="pointer" name="refresh-4" @click="playerAction('go-prev')" />
				<base-icon v-if="audioIsPlaying" class="pointer play-pause" name="btn-pause" @click="playerAction('play')" />
				<base-icon v-else class="pointer play-pause" name="btn-play-1" @click="playerAction('play')" />
				<base-icon class="pointer" name="refresh-3" @click="playerAction('go-next')" />
				<base-icon :class="`${stages.length <= 3 ? 'deactivated' : 'pointer'}`" name="pointing-right-1" @click="playerAction('go-next-stage')" />
			</div>
			<!-- <div class="audio-player-change-capitalize-first pointer" @click="changeLan">{{$t('scrolly_cambio_lingua_player')}}</div> -->
		</div>
		<audio v-if="media['audio-scrolly-ogg']" preload="metadata" style="visibility: hidden"  @timeupdate="onTimeUpdate">
			<source :src="media[`audio-scrolly${$i18n.locale == 'en' ? '-en' : ''}-ogg`].url" type="audio/ogg">
			<source :src="media[`audio-scrolly${$i18n.locale == 'en' ? '-en' : ''}-aac`].url" type="audio/aac">
		</audio>
	</main>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';
import { nextTick } from 'vue';
import { mapState, mapActions } from 'vuex';
import { select } from 'd3-selection';
import cloneDeep from 'lodash.clonedeep';
import moment from 'moment-mini'

export default {
	name: 'InterfaceAudioPlayer',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		audio: {
			type: Object,
			default: {}
		},
		srtFile: {
			type: String
		},
		title: {
			type: String,
			default: ''
		},
		stages: {
			type: Array
		},
		scrollyId: {
			type: Number
		},
		media: {
			type: Object
		}
	},
	data() {
		return {
			audioIsPlaying: false,
			duration: -1,
			progress: 0,
			seekAmount: 5,
			localLan: ''
		}
	},
	computed: {
		...mapState({
			audioBookmarks: state => state.audioBookmarks
		}),
		audioSource() {
			return this.audio.url ? this.audio.url : ''
		},
		progressAmount() {
			// console.log(this.progress, document.querySelector('.audio-player-progress-bar'))
			if( this.progress > 0) {
				let bb = document.querySelector('.audio-player-progress-bar').getBoundingClientRect();
				return utils.map(this.progress, 0, this.duration, 0, bb.width)
			}else {
				return 0;
			}
		},
		progressStyle() {
			return `width: ${this.progressAmount}px;`
		},
		audioSpots() {
			return this.stages.map(el => ({it: el.audioSpotIt, en: el.audioSpotEn}))
		},
		currentStage() {
			if(this.progress > 0) {
				let rtn = this.audioSpots.filter(as => this.progress > as[this.$i18n.locale])

				if(!rtn.length) return null

				let number = Math.max(...this.audioSpots.filter(as => this.progress > as[this.$i18n.locale]).map(el => el[this.$i18n.locale]))
				return this.stages.find(el => el[`audioSpot${this.$i18n.locale== 'it' ? 'It' : 'En'}`] == number)
			}else {
				return this.stages[0]
			}
		},
		currentStageString() {
			if(this.currentStage) {
				return this.currentStage.name[this.$i18n.locale]
			}else {
				return ''
			}
		},
		timeProgress() {
			// let parseStr = str => str.length == 1 ? '0' + str : str

			let rtn =  this.duration > -1 ? `${this.secondsToString(this.progress)}/${this.secondsToString(this.duration)}` : `00:00/00:00`
				// `${parseStr(parseInt(this.progress/60).toString())}:${parseStr(parseInt(this.progress%60).toString())}/${parseStr(parseInt(this.duration/60).toString())}:${parseStr(parseInt(this.duration%60).toString())}` : 
				// '00:00/00:00'

			return rtn
		}
	},
	watch: {
		visible(n, o) {
			if(!n && o) {
				document.querySelector('.audio-player-cont audio').pause();
				this.audioIsPlaying = false;
				this.saveBookmark()
			}
			this.togglePayer(n)
		},
		async media(n) {
			// console.log('new media', cloneDeep(n))
			if(n['audio-scrolly-aac']) {
				await nextTick()
				this.addEventListeners();
			}
		}
	},
	methods: {
		...mapActions([
			'addAudioBookmark', 
			'removeAudioBookmark'
		]),
		getCurrentStage() {
			if(this.progress > 0) {
				let rtn = this.audioSpots.filter(as => this.progress > as[this.$i18n.locale])
				if(!rtn.length) return null

				let number = Math.max(...this.audioSpots.filter(as => this.progress > as[this.$i18n.locale]))
				return this.stages.find(el => el[`audioSpot${this.$i18n.locale== 'it' ? 'It' : 'En'}`] == number)
			}else {
				return this.stages[0]
			}
		},
		secondsToString(numSeconds) {
			// Assuming you have the total seconds stored in a variable called "totalSeconds"

			// Convert the total seconds into a moment duration
			const duration = moment.duration(numSeconds, 'seconds');

			// Retrieve the hours, minutes, and seconds from the duration
			const hours = duration.hours();
			const minutes = duration.minutes();
			const seconds = duration.seconds();

			return `${this.addZeroIfNecessary(hours)}:${this.addZeroIfNecessary(minutes)}:${this.addZeroIfNecessary(seconds)}`
		},
		addZeroIfNecessary(num) {
			// console.log('num', num)
			let numString = num.toString();
			if(numString.length == 1) {
				return '0'+numString
			}else {
				return numString
			}
		},
		playerAction(action) {
			let player = document.querySelector('.audio-player-cont audio')
			switch (action) {
				case 'play':
					if(this.audioIsPlaying) {
						player.pause();
						this.audioIsPlaying = false;
					}else {
						player.play();	
						this.audioIsPlaying = true;
					}
					break;
				case 'go-prev':
					if(player.currentTime - this.seekAmount > 0) {
						player.currentTime = player.currentTime - this.seekAmount
					}else {
						player.currentTime = 0;
					}
					break;
				case 'go-next':
					if(player.currentTime + this.seekAmount < this.duration) {
						player.currentTime = player.currentTime + this.seekAmount
					}
					break;
				case 'go-prev-stage':
					 var ids = this.stages.map(el => el.id)
					var currIndex = ids.indexOf(this.currentStage.id)
					var lastIndex = ids.indexOf(this.stages[this.stages.length-1].id);
					if(currIndex > 0) {
						player.currentTime = this.stages[currIndex-1][`audioSpot${this.$i18n.locale== 'it' ? 'It' : 'En'}`]
					}else {
						// player.currentTime = this.stages.find(el => el.id == this.stages.length-1).audioSpot
					}
					// player.currentTime = 0;
					break;
				case 'go-next-stage':
					var ids = this.stages.map(el => el.id)
					var currIndex = ids.indexOf(this.currentStage.id)
					var lastIndex = ids.indexOf(this.stages[this.stages.length-1].id);
					// console.log(currIndex, lastIndex, cloneDeep(ids))
					if(currIndex < lastIndex - 1) {
						player.currentTime = this.stages[currIndex+1][`audioSpot${this.$i18n.locale == 'it' ? 'It' : 'En'}`]
					}else {
						// player.currentTime = this.stages.find(el => el.id == this.stages.length-1).audioSpot
					}
					break;
			}
		},
		exitPlayer() {
			this.$emit('exit-player')
		},
		addEventListeners() {
			let audio = document.querySelector('.audio-player-cont audio')
			let me = this;
			audio.onloadedmetadata = function() {
				me.duration = this.duration;
				me.createSpots();
				me.stages[me.stages.length-1][`audioSpot${me.$i18n.locale == 'it' ? 'It' : 'En'}`] = this.duration
			}
			audio.ontimeupdate = function(e) {
				window.requestAnimationFrame(() => {
					if(me.audioIsPlaying) {
						me.progress = this.currentTime
					}
				})
			}

			audio.onplay = () => {
				this.audioIsPlaying = true;
			}

			audio.onended = () => {
				this.audioIsPlaying = false;
				this.removeBookmark({
					id: this.scrollyId
				})
			}

			document.querySelector('.audio-player-cont').addEventListener('wheel', utils.stopPropagation, {passive: false})

			let ab = this.audioBookmarks.find(el => el.id == this.scrollyId)

			if(this.audioBookmarks.length && ab) {
				this.seekPlayer(ab.time)
			}
		},
		createSpots() {
			let bb = document.querySelector('.audio-player-progress-bar').getBoundingClientRect();
			// console.log('building spots', this.audioSpots, bb)
			// console.log('duration', this.duration)
			select('.audio-player-progress-bar')
				.selectAll('.audio-player-spot')
				.data(this.audioSpots.map(el => el[this.$i18n.locale]))
				.enter()
				.append('div')
				.attr('class', 'audio-player-spot')
				.attr('style', d => `left: ${utils.map(d, 0, this.duration, 0, bb.width)}px;`)
		},
		changeLan() {
			this.$i18n.locale = this.$i18n.locale == 'en' ? 'it' : 'en'
		},
		saveBookmark() {
			this.addAudioBookmark({
				id: this.scrollyId,
				time: this.progress
			})
		},
		removeBookmark() {
			this.removeAudioBookmark({
				id: this.scrollyId
			})
		},
		seekPlayer(time) {
			let player = document.querySelector('.audio-player-cont audio')
			player.pause();
			this.audioIsPlaying = false;
			document.querySelector('.audio-player-cont audio').currentTime = time
		},
		togglePayer(bool) {
			let endTransition = e => {
				if(e.propertyName == 'opacity' && !this.visible) {
					document.querySelector('.audio-player-cont').style.zIndex = '-1';
				}
			}
			if(bool) {
				document.querySelector('.audio-player-cont').style.zIndex = '5';
				document.querySelector('.audio-player-cont').style.opacity ='1'
			}else {
				document.querySelector('.audio-player-cont').style.opacity ='0'
			}
			document.querySelector('.audio-player-cont').ontransitionend = endTransition
		}
	},
	mounted() {
		utils.isElLoaded('.audio-player-cont audio')
			.then(() => {
				// this.addEventListeners();
			}) 
	},
	beforeUnmount() {
		document.querySelector('.audio-player-cont').removeEventListener('wheel', utils.stopPropagation)
	}
}

</script>

<style lang="scss">
	
	@import '@css/variables.scss';

	.audio-player-cont {
		position: fixed;
		left: var(--menu-size);
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
    align-items: center;
    justify-content: center;
    isolation: isolate;
    opacity: 0;
		z-index: -1;
		background-color: var(--color-brand-blue);
		color: var(--color-white);
		transition-property: opacity;
		transition-duration: .5s;
		overflow-y: auto;
	}

	.audio-player-gradient {
		position: absolute;
		left: 0;
		top: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
	}

	.audio-player-logo {
		position: absolute;
		left: 50%;
		top: 4.6rem;
		width: 10rem;
		transform: translate(-50%, 0);
		--svg-icon-color: var(--color-white);
	}

	.audio-player-cont .stack-vertical,
	.audio-player-cont .stack-horizontal {
		justify-content: center;
		align-items: center;
	}

	.audio-player-cont h2, .audio-player-cont p {
		text-align: center;
	}

	.audio-player-cont.visible {
		opacity: 1;
	}

	.audio-player-top {
		position: absolute;
		top: 4.625rem;
		left: 4.375rem;
		right: 4.375rem;
		margin: auto;
		text-align: center;

		display: flex;
		justify-content: space-between;
		align-items: center;

		.audio-player-spacer {
			width: var(--s4);
		}
	}

	.audio-player-elements, 
	.audio-player-contents,
	.audio-player-texts {
		gap: var(--s3); 
	}

	.audio-player-title {
		gap: var(--s2);
		max-width: 32rem;
	}

	.audio-player-controls {
		gap: 3.125rem;
	}

	.audio-player-controls .svg-icon {
		width: 1.75rem;
		height: 1.75rem;
		--svg-icon-color: var(--color-white);
	}

	.audio-player-controls .deactivated {
		pointer-events: none;
	}

	.audio-player-controls .deactivated.svg-icon {
		opacity: 0.5;
	}

	.audio-player-controls .svg-icon.play-pause {
		width: 3.75rem;
		height: 3.75rem;
	}

	.audio-player-progress-bar {
		background-color: var(--color-gray-text);
		width: 50rem;
		height: 3px;
		border-radius: 100rem;
	}

	.audio-player-progress-amount {
		height: 3px;
		background-color: var(--color-white);
	}

	.audio-player-spot {
		position: absolute;
		top: 50%;
		width: 1rem;
		height: 1rem;
		transform: translate(0, -50%);
		background-color: var(--color-gold);
		border-radius: 100rem;
	}

	.audio-player-progress-index {
		position: absolute;
		top: 50%;
		left: 0;
		transform: translate(0, -50%);
		width: 1.5rem;
		height: 1.5rem;
		background-color: var(--color-gold);
		border-radius: 100rem;
	}

	@media (max-width: $breakpoint-sm) {
		.audio-player-cont {
			left: 0;
			top: var(--menu-size);
		}

		.audio-player-elements {
			margin: 3rem 1.5rem;
		}

		.audio-player-progress-bar {
			width: 80vw;
		}

		.audio-player-controls {
			gap: var(--s3);
		}

		.audio-player-top {
		  top: var(--s2);
		  left: 1.25rem;
		  right: 1.25rem;

			.audio-player-spacer {
				width: 3rem;
			}
		}

		.audio-player-progress-index {
			position: absolute;
			width: 0.85rem;
			height: 0.85rem;
		}

		.audio-player-spot {
			width: 0.5rem;
			height: 0.5rem;
		}
	}

</style>
